import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerNavModule } from './extensions/channel-banner/banner-nav.module';
import { CompleteOrderButtonModule } from './extensions/3384388b202f74eab7c2868b463e157bff67f3c0ad6e936f80521c1ce88fe634/complete-order-button.module';
import { CancelOrderButtonModule } from './extensions/5de37f7c6e1fa2b3fdacb102c66d3d517b19a97039860c30a47c4a74d163e89e/cancel-order-button.module';
import { WebhookNavModule } from './extensions/webhook/webhook-nav.module';

import SharedProviders_4_0 from './extensions/sellers-ui/providers';
import SharedProviders_5_0 from './extensions/customer-channel-ui/providers';


@NgModule({
    imports: [CommonModule, BannerNavModule, CompleteOrderButtonModule, CancelOrderButtonModule, WebhookNavModule],
    providers: [...SharedProviders_4_0, ...SharedProviders_5_0],
})
export class SharedExtensionsModule {}
